import api from '../index'

export default {

    /**
     * Get
     * @param params
     */
    get(params) {
        return api
            .get(`/billing/products`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Show
     * @param product
     * @param params
     */
    show(product, params) {
        return api
            .get(`/billing/products/${product}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create
     * @param data
     */
    create(data) {
        return api
            .post(`/billing/products`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Update
     * @param product
     * @param data
     */
    update(product, data) {
        return api
            .put(`/billing/products/${product}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete
     * @param billingAccount
     */
    delete(billingAccount) {
        return api
            .delete(`/billing/products/${product}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show by slug
     * @param slug
     * @param params
     */
    showBySlug(slug, params) {
        return api
            .get(`/billing/products/slug/${slug}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update price
     * @param product
     * @param data
     */
    updatePrice(product, data) {
        return api
            .put(`/billing/products/${product}/price`, data)
            .then(response => {
                return response.data
            })
    },

}
